module.exports = __webpack_public_path__ + "img/gift-box-left.5f3399f2.svg";